// PROD-1104: the deliver patch ONE updateDeliverTask call sends to the API. It is built from `data`
// alone, never from the page-load copy of `deliver`: a copy resent on every write overwrote what the
// MD side or a job had changed in between (the API deep-merges a partial deliver, so a key this call
// does not send survives). A file list is sent only when the caller passes one, and only the entries
// the caller passes (the API merges per entry); removals travel separately as deliver._remove.
const firstArray = (...vals) => vals.find(v => Array.isArray(v))
const put = (patch, key, val) => { if (val !== undefined) patch[key] = val }

export function buildDeliverPatch(taskType, data) {
  const d = data && typeof data === 'object' ? data : {}
  const patch = {}
  switch (taskType) {
    case 'medication':
      return { medicationSurveyComplete: true, medicationSurvey: data }
    case 'radiology':
    case 'imaging': {
      const done = d.completed ?? d.imagingComplete
      put(patch, 'radiologyComplete', done)
      put(patch, 'imagingComplete', done)
      put(patch, 'radiologyFiles', firstArray(d.files, d.imagingFiles, d.radiologyFiles))
      if (d.imagingCompletedAt) patch.imagingCompletedAt = d.imagingCompletedAt
      for (const k of ['imagingFacility', 'imagingAuth', 'imagingStatus', 'imagingPrep', 'imagingBookingUrl', 'imagingAppointment']) put(patch, k, d[k])
      return patch
    }
    case 'labs': {
      put(patch, 'labsComplete', d.completed ?? d.labsComplete)
      put(patch, 'labsFiles', firstArray(d.files, d.labsFiles))
      if (d.labsCompletedAt) patch.labsCompletedAt = d.labsCompletedAt
      for (const k of ['labsFacility', 'labsAuth', 'labsStatus', 'labsPrep', 'labsBookingUrl', 'labsAppointment']) put(patch, k, d[k])
      return patch
    }
    default:
      // careOrders / additionalOrders / diagnosticTests / dme / procedures / customOrders / referrals / other
      // and any future task: InstructionsScreen passes properly-keyed data.
      return { ...d }
  }
}
